<template>
	<div class="richtext-component" :styles="textAlign" v-html="sanitizeContent(text)"></div>
	<slot />
	<div v-if="richTextButton" v-for="(button, index) in richTextButton" :key="index">
		<Button :data="button" :button="'secondary medium'"></Button>
	</div>
</template>

<script setup>
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { MARKS } from '@contentful/rich-text-types';
import {useSanitize} from "~~/composables/useSanitize.js";

const { $getUnderlinedNodes } = useNuxtApp();
const { sanitizeContent } = useSanitize();

const props = defineProps({
	textAlignment: String,
	content: {
		type: Array,
		required: true
	}
});

const options = {
	renderMark: {
		[MARKS.BOLD]: (text) => `<strong>${text}</strong>`,
		[MARKS.ITALIC]: (text) => `<em>${text}</em>`,
		[MARKS.UNDERLINE]: (text) => `<u>${text}</u>`,
	}
};

const richTextButton = ref($getUnderlinedNodes(props.content));

richTextButton.value = richTextButton.value.map(object => ({
	...object,
	style: 'secondary',
	size: 'medium'
}));

const textAlign = `text-align:${props.textAlignment}`;
const text = computed(() => {
	if (!props.content || props.content.length === 0) {
		console.warn('Content is empty or undefined');
		return '';
	}

	const document = {
		nodeType: 'document',
		data: {},
		content: [
			{
				nodeType: 'paragraph',
				data: {},
				content: props.content
			}
		]
	};

	return documentToHtmlString(document, options);
});
</script>

<style lang="scss">
@use '~/assets/scss/components/RichText.scss';
</style>

